
(() => {
  const originals = new WeakMap();
  const swatchSelector =
    'button.product-tile__swatch[data-aa-variant-image]';

  function preview(swatch) {
    const url = swatch.dataset.aaVariantImage;
    const tile = swatch.closest('article.product-tile');
    if (!url || !tile) return;

    const image = tile.querySelector(
      '.product-tile__image--primary'
    );
    const secondary = tile.querySelector(
      '.product-tile__image--secondary'
    );
    if (!image) return;

    if (!originals.has(tile)) {
      originals.set(tile, {
        image,
        secondary,
        src: image.getAttribute('src'),
        srcset: image.getAttribute('srcset'),
        primaryStyle: image.getAttribute('style'),
        secondaryStyle: secondary?.getAttribute('style')
      });
    }

    image.removeAttribute('srcset');
    image.src = url;
    image.style.setProperty('opacity', '1', 'important');

    if (secondary) {
      secondary.style.setProperty(
        'display', 'none', 'important'
      );
    }
  }

  function restore(tile) {
    const saved = originals.get(tile);
    if (!saved) return;

    for (const [name, value] of [
      ['src', saved.src],
      ['srcset', saved.srcset],
      ['style', saved.primaryStyle]
    ]) {
      if (value === null) {
        saved.image.removeAttribute(name);
      } else {
        saved.image.setAttribute(name, value);
      }
    }

    if (saved.secondary) {
      if (saved.secondaryStyle === null) {
        saved.secondary.removeAttribute('style');
      } else {
        saved.secondary.setAttribute(
          'style', saved.secondaryStyle
        );
      }
    }

    originals.delete(tile);
  }

  document.addEventListener('mouseover', (event) => {
    const swatch = event.target.closest?.(swatchSelector);
    if (swatch) preview(swatch);
  });

  document.addEventListener('mouseout', (event) => {
    const swatch = event.target.closest?.(swatchSelector);
    if (swatch) {
      const tile = swatch.closest('article.product-tile');
      
if (tile) {
  const selected = tile.querySelector('.aa-swatch-selected');
  if (selected) {
    preview(selected);
  } else {
    restore(tile);
  }
}

    }
  });

document.addEventListener('click', (event) => {
  const swatch = event.target.closest?.(swatchSelector);
  if (!swatch) return;

  event.preventDefault();
  event.stopPropagation();

  const tile = swatch.closest('article.product-tile');
  if (!tile) return;

  tile.querySelectorAll(swatchSelector).forEach(button => {
    const selected = button === swatch;
    button.classList.toggle('aa-swatch-selected', selected);
    button.setAttribute('aria-pressed', String(selected));
  });

  preview(swatch);

const variantUrl = swatch.dataset.aaVariantUrl;

if (variantUrl) {
  const variantId = new URL(
    variantUrl, window.location.origin
  ).searchParams.get('variant');

  if (variantId) {
    tile.querySelectorAll('a[href*="/products/"]')
      .forEach(link => {
        const target = new URL(link.href);
        target.searchParams.set('variant', variantId);
        link.href = target.href;
      });
  }
}

}, true);

})();
